<template>
  <div v-if="!itemRelation" class="text-left">
    <h5>
      {{ $t("form." + field + ".name") }}
    </h5>
    <v-row>
      <v-col cols="12" md="5">
        <v-text-field
          :value="attribute.name"
          :label="$t('form.not_item_relation')"
          required
          hide-details
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="6" md="3" v-if="attribute.id !== 'delete'">
        <v-autocomplete
          :items="workplaceOptions"
          item-text="name"
          item-value="name"
          :label="$t('form.laboratory')"
          v-model="laboratory"
          required
          outlined
          hide-details
          @change="resetItemSelected"
          :readonly="readOnly"
          clearable
          cache-items
          hide-no-data
          :menu-props="{ maxHeight: 300 }"
        ></v-autocomplete>
      </v-col>
      <v-col cols="5" sm="5" md="3" lg="3" v-if="attribute.id !== 'delete'">
        <v-autocomplete
          :items="workplaceOptions.filter(item => item.name === laboratory)"
          item-text="place_code"
          :return-object="true"
          :label="$t('form.place')"
          required
          outlined
          ref="select2"
          hide-details
          @change="changeSelect($event)"
          :disabled="laboratory === ''"
          :readonly="readOnly"
          clearable
          cache-items
          hide-no-data
          :menu-props="{ maxHeight: 300 }"
        ></v-autocomplete>
      </v-col>
      <v-col cols="11" sm="6" v-else class="rounded">
        <v-text-field outlined readonly :value="$t('form.relation_item_removed')"></v-text-field>
      </v-col>
      <v-col cols="1" v-if="attribute.id !== 'delete'">
        <v-btn icon color="red" class="mt-2" @click="deleteItem()">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col cols="5" sm="3" md="2" lg="1">
        <v-btn
            @click="submit"
            :disabled="save || readOnly"
            color="light-green"
        >
          {{ $t("button.save") }}
        </v-btn></v-col
      >
    </v-row>
  </div>
  <div v-else class="text-left">
    <h5>
      {{ $t("form." + field) }}
    </h5>
    <v-row>
      <v-col cols="12" md="6">
        <v-alert dense text type="success">
          {{ $t("processor.itemRelation.correct") }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    dataModOp: Object,
    state: String,
    workplaceOptions: Array
  },
  name: "AssignRelationField",
  data: () => ({
    field: "workplace",
    laboratory: "",
    attribute: "",
    save: true
  }),

  created() {
    this.initialize();
  },

  computed: {
    itemRelation: function() {
      return typeof this.attribute == "number" || this.attribute === null;
    },

    readOnly: function() {
      return this.state === "PC";
    }
  },

  mounted() {
    this.loadSelectedOptions();
  },
  methods: {
    getField(lookup, obj = this.dataModOp.user) {
      for (const x in obj) {
        if (x === lookup) {
          if (typeof obj[x] == "object" && obj[x] !== null) {
            this.attribute = Object.assign({}, obj[x]);
          } else {
            this.attribute = obj[x];
          }
        } else if (obj[x] instanceof Object) {
          this.getField(lookup, obj[x]);
        }
      }
    },
    initialize() {
      if (
        this.dataModOp.supervisor !== undefined &&
        this.dataModOp.supervisor[this.field] !== undefined
      ) {
        this.getField(this.field, this.dataModOp.supervisor);
      } else {
        this.getField(this.field, this.dataModOp.user);
      }
    },

    loadSelectedOptions() {
      if (this.attribute.id != null) {
        this.workplaceOptions.forEach(itemFromdb => {
          if (this.attribute.id === itemFromdb.id) {
            this.laboratory = itemFromdb.name;
            this.$nextTick(() => {
              this.$refs["select2"].selectedItems = [];
              this.$refs["select2"].selectedItems.push(itemFromdb);
            });
          }
        });
      }
    },

    submit() {
      let data = {
        data: {
          user: this.dataModOp.user,
          supervisor: {}
        }
      };
      if (this.dataModOp.supervisor !== undefined) {
        data["data"]["supervisor"] = this.dataModOp.supervisor;
      }
      data["data"]["supervisor"][this.field] = this.attribute;
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/" +
        this.$route.params.id;
      axios
        .patch(path, data)
        .then(response => {
          this.$emit("update-modOp-data", data.data);
          this.$store.commit("alert", {
            color: "success",
            text: this.$t('form.select_item_relation_success')
          });
          this.save = true;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    },
    changeSelect(itemSelected) {
      this.attribute.id = itemSelected.id;
      this.save = false;
    },

    resetItemSelected() {
      this.attribute.id = null;
      this.save = true;
    },
    deleteItem(){
      this.attribute.id = 'delete'
      this.save = false;
    }
  }
};
</script>

<style scoped></style>
